module.exports = __webpack_public_path__ + "media/images/iconSearch__okGreen--dark-e10079091ba02a04ec4ae0ff9b618cfd.png";